/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgerdeduction2Inputs */

const zh_adminsubs_ledgerdeduction2 = /** @type {(inputs: Adminsubs_Ledgerdeduction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消耗`)
};

const en_adminsubs_ledgerdeduction2 = /** @type {(inputs: Adminsubs_Ledgerdeduction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deduction`)
};

const es_adminsubs_ledgerdeduction2 = /** @type {(inputs: Adminsubs_Ledgerdeduction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumo`)
};

/**
* | output |
* | --- |
* | "Deduction" |
*
* @param {Adminsubs_Ledgerdeduction2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgerdeduction2 = /** @type {((inputs?: Adminsubs_Ledgerdeduction2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgerdeduction2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgerdeduction2(inputs)
	if (locale === "en") return en_adminsubs_ledgerdeduction2(inputs)
	return es_adminsubs_ledgerdeduction2(inputs)
});
export { adminsubs_ledgerdeduction2 as "adminSubs_ledgerDeduction" }